<template>
  <div>
    <div class="row">
      <div class="col-6">
        <form v-on:submit.prevent="GetDataSearch" class="form">
          <label for="email">Filter users.</label>
          <input
            type="text"
            class="input"
            placeholder="Email, Name..."
            v-model="search"
          />
        </form>
      </div>
      <div class="col-6">
        <router-link class="btn btn-green float-right" to="/Admin/Users/New"
          ><i class="icon icon-user-plus"></i> New User</router-link
        >
      </div>
      <div class="col-12">
        <table>
          <thead>
            <tr>
              <td
                v-for="column in columns"
                :key="column.name"
                @click="column.sortable === true ? sortBy(column.name) : ''"
                :class="
                  sortKey === column.name
                    ? sortOrders[column.name] > 0
                      ? 'headerSortUp'
                      : 'headerSortDown'
                    : ''
                "
                :style="'width:' + column.width + ';' + 'cursor:pointer;'"
              >
                {{ column.label }}
              </td>
              <td><i class="icon icon-cogs"></i></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in tblrows" :key="row.id">
              <td>{{ row.id }}</td>
              <td>
                <i
                  v-if="row.is_staff"
                  class="icon icon-logo"
                  style="color: #35bba4"
                ></i>
                {{ row.name }}
              </td>
              <td>{{ row.email }}</td>
              <td>{{ row.country }}</td>
              <td v-if="row.is_email_confirmed == true">
                <i class="icon icon-check" style="color: green"></i>
              </td>
              <td v-else><i class="icon icon-cross" style="color: red"></i></td>
              <td>{{ row.available_test }}</td>
              <td>
                <router-link
                  :to="{ name: 'Admin_Users_Modify', params: { id: row.id } }"
                  class="btn btn-orange"
                  >Modify</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        Displaying {{ count }} of {{ total_filter }}. Total of {{ total }} rows.
      </div>
      <div class="col-6">
        <div class="btn-group float-right">
          <div class="btn btn-green" v-on:click="GetDataPrev">
            &larr; PREVIOUS
          </div>
          <div class="btn btn-green" v-on:click="GetDataNext">NEXT &rarr;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
export default {
  name: "Admin_Users_ListDatatable",
  setup() {
    const store = useStore();

    return { store };
  },
  data() {
    let sortOrders = {};
    let columns = [
      { width: "auto", label: "ID", name: "id", sortable: true },
      { width: "auto", label: "Name", name: "name", sortable: true },
      { width: "auto", label: "Email Address", name: "email", sortable: true },
      { width: "auto", label: "Country", name: "country", sortable: true },
      {
        width: "auto",
        label: "Account Activated",
        name: "is_email_active",
        sortable: true,
      },
      {
        width: "auto",
        label: "Available Tests",
        name: "available_test",
        sortable: true,
      },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      tblrows: [],
      count: 0,
      order: [0, "DESC"],
      search: "",
      offset: 0,
      total: 0,
      limit: 20,
      total_filter: 0,
      next: 0,
      prev: 0,
      columns: columns,
      sortKey: "id",
      sortOrders: sortOrders,
    };
  },
  methods: {
    GetData() {
      let body = {
        search: this.search,
        order: this.order,
        limit: this.limit,
        offset: this.offset,
      };
      this.store
        .dispatch("Admin/GetUsersDatatable", body)
        .then((result) => {
          this.total = result.total;
          this.total_filter = result.total_filter;
          this.tblrows = result.data;
          this.count = this.offset + this.tblrows.length;
          this.prev =
            this.offset - this.limit < 0 ? 0 : this.offset - this.limit;
          this.next =
            this.offset + this.tblrows.length > this.total_filter
              ? this.total_filter
              : this.offset + this.tblrows.length;
        })
        .catch((err) => {
          console.log(err);
          this.total = 0;
          this.total_filter = 0;
          this.tblrows = [];
          this.count = 0;
          this.prev = 0;
          this.next = 0;
        });
    },
    GetDataSearch() {
      this.tblrows = [];
      this.offset = 0;

      this.GetData();
    },
    GetDataNext() {
      if (this.next != this.total_filter) {
        console.log(this.next);
        this.offset = this.next;
        this.GetData();
      }
    },
    GetDataPrev() {
      if (this.offset !== 0) {
        this.offset = this.prev;
        this.GetData();
      }
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      let name = this.getIndex(this.columns, "name", key);
      let dir = this.sortOrders[key] > 0 ? "ASC" : "DESC";
      this.order = [name, dir];

      this.GetData();
    },
  },
  mounted() {
    this.GetData();
  },
};
</script>

<style></style>
